"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImage = void 0;
const isString_1 = require("./isString");
function getImage(name) {
    try {
        const module = require(`../components/assets/diversity/${name}.png`);
        return (0, isString_1.isString)(module) ? module : module.default;
    }
    catch (e) {
        return '';
    }
}
exports.getImage = getImage;
